import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-33c37ad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "userLayout",
  class: /*#__PURE__*/_normalizeClass(['user-layout-wrapper'])
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-layout-lang" }, null, -1))
const _hoisted_4 = { class: "user-layout-content" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-33c37ad8><div class=\"header\" data-v-33c37ad8><a href=\"/\" data-v-33c37ad8><img src=\"" + _imports_0 + "\" class=\"logo\" alt=\"logo\" data-v-33c37ad8><span class=\"title\" data-v-33c37ad8>管店宝</span></a></div><div class=\"desc\" data-v-33c37ad8> </div></div>", 1)

import Footer from '@/components/Footer.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_router_view, { class: "main-content" }),
        _createVNode(Footer)
      ])
    ])
  ]))
}
}

})